import { createUseStyles } from 'react-jss';
import { SurveyContainerStyle, CommonStyle } from '@sm/webassets/SurveyTheme/types';
import { isOQAATFullBleed, isCityLights } from '~app/helpers/themeLayout';

type v2SurveyTitleStyleProps = {
  surveyTitle?: CommonStyle;
  isOQAAT: boolean;
  backgroundColor?: string;
  backgroundImage?: string;
  surveyContainer?: SurveyContainerStyle;
};

const useV2Styles = createUseStyles({
  surveyTitleContainerV2: ({
    backgroundColor,
    isOQAAT,
    surveyTitle,
    backgroundImage,
    surveyContainer,
  }: v2SurveyTitleStyleProps) => {
    return {
      paddingLeft: '40px',
      paddingRight: '40px',
      backgroundColor,
      ...(isOQAATFullBleed(surveyContainer, isOQAAT) && {
        position: 'relative',
        width: 'calc(100vw - 80px)',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
      }),
      ...(isCityLights(surveyTitle) && {
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundImage,
      }),
    };
  },
});

export default useV2Styles;
